import { Injectable } from '@angular/core';
import { DBMode, NgxIndexedDBService, NgxIDBCursorWithValue } from 'ngx-indexed-db';
import { map, from, Observable, of, catchError } from 'rxjs';

export interface IEmpresa {
  company_id: string;
  company_name: string;
  company_groups: Array<{
      company_group_id: number;
      company_group_name: string;
  }>;
}

export interface IAssessmentStatus extends IEmpresa {
  assessment_id: number;
  risk: {
    risk_source_type_id: number;
    risk_source_id: number;
    risk_name: string;
  };
  model?: any;
}

export interface IRiskThumbnail {
  thumbnail_id: number; // <- auntoIncrement BBDD
  assessment_id: number;
  risk_source_id: number;
  thumbnail: string; // Base64 string
  metadata: any;
}

// implementació mínima, de moment un key-value storage sense més
const OBJSTORE: string = 'objects'; // <- definit a main.ts
const COMPANIES_STORE: string = 'empreses'; // "
const THUMBNAILS = 'riskThumbnails';

@Injectable({
  providedIn: 'root'
})
export class IndexedStorageService {

  constructor(
    private db: NgxIndexedDBService,
  ) {
    console.log(this.db,'test database')
  }

  dbSet(key:string, value: any) {
    return this.db.add(OBJSTORE, value, key);
  }

  dbGet<T>(key:string) {
    return this.db.getByKey<T>(OBJSTORE, key);
  }

  dbRemove(key:string) {
    return this.db.deleteByKey(OBJSTORE, key);
  }

  // storeEmpreses(empreses: IEmpresa[]) {
  //   return this.db.bulkPut(COMPANIES_STORE, empreses);
  // }

  // removeEmpresa(company_id:string) {
  //   return this.db.delete<IEmpresa>(COMPANIES_STORE, company_id);
  // }

  // avaliableEmpreses() {
  //   return this.db.getAll<IEmpresa>(COMPANIES_STORE);
  // }

  // // provant estratègies de cerca
  // filtreEmpreses( term:string ) {
  //   const keyRange = IDBKeyRange.bound(term, `${term}\ufff0`, false, false);//IDBKeyRange.bound(term, `${term}\ufff0`, false, true);
  //   return this.db.openCursorByIndex({
  //     storeName:COMPANIES_STORE,
  //     indexName: 'name',
  //     query: keyRange, 
  //     mode:DBMode.readonly 
  //   }).pipe(
  //     // map((cursor) =>{
  //     //   return cursor.value;
  //     // }),
  //   );
  // }

  // ========== Risk Assessments ==========
  
  /**
   * Create a new risk assessment
   */
  createRiskAssessment(data: IAssessmentStatus): Observable<IAssessmentStatus> {
    return this.db.add('riskAssessments', data).pipe(
      //catchError(this.handleError<IAssessmentStatus>('createRiskAssessment'))
    );
  }

  /**
   * Get all risk assessments
   */
  getRiskAssessments(): Observable<IAssessmentStatus[]> {
    return this.db.getAll<IAssessmentStatus>('riskAssessments').pipe(
      catchError(this.handleError<IAssessmentStatus[]>('getRiskAssessments', []))
    );
  }

  /**
   * Get assessment by composite key
   */
  getRiskAssessment(
    assessmentId: number,
    riskSourceId: number
  ): Observable<IAssessmentStatus | null> {
    const key = [assessmentId, riskSourceId];
    return this.db.getByKey('riskAssessments', key).pipe(
      map((result) => result as IAssessmentStatus),
      catchError(this.handleError<IAssessmentStatus|null>('getRiskAssessment', null))
    );
  }

  /**
   * Delete risk assessment
   */
  deleteRiskAssessment(
    assessmentId: number,
    riskSourceId: number
  ): Observable<boolean> {
    const key = [assessmentId, riskSourceId];
    return this.db.delete('riskAssessments', key).pipe(
      map((deleted) => !!deleted.length),
      catchError(this.handleError<boolean>('deleteRiskAssessment', false))
    );
  }

  // ========== Risk Thumbnails ==========
  
  /**
   * Create/Update thumbnail for assessment/risk source
   */
  setThumbnail(
    assessmentId: number,
    riskSourceId: number,
    thumbnail: string,
    metadata: any
  ): Observable<IRiskThumbnail> {

    const key = [assessmentId, riskSourceId];
    const data: Partial<IRiskThumbnail> = {
      assessment_id: assessmentId,
      risk_source_id: riskSourceId,
      thumbnail,
      metadata
    };
    
    return this.db.add('riskThumbnails', data).pipe(
      map((id) => id as IRiskThumbnail),
      //catchError(this.handleError<IRiskThumbnail>('setThumbnail', {} as IRiskThumbnail))
    );
  }

updateThumbnail(modelData:IRiskThumbnail): Observable<IRiskThumbnail> {  
  return this.db.update('riskThumbnails', modelData)
}

  /**
   * Get thumbnails by assessment/risk source
   */
  getThumbnails(
    assessmentId: number,
    riskSourceId: number
  ): Observable<IRiskThumbnail[]> {
    const key = [assessmentId, riskSourceId];
    return this.db.getAllByIndex<IRiskThumbnail>(
      THUMBNAILS, 'byAsssessmentThumb', IDBKeyRange.only(assessmentId)
    ).pipe(
      map((lst)=>lst.filter((e)=>e.risk_source_id==riskSourceId))
    )
  }

  /**
   * Delete thumbnail
   */
  deleteThumbnail(
    thumbnail_id: number
  ): Observable<boolean> {
    return <Observable<boolean>>this.db.delete(THUMBNAILS, thumbnail_id).pipe(
      catchError(this.handleError<boolean>('deleteThumbnail', false))
    );
  }

  // ========== Helper Methods ==========
  
  private handleError<T>(operation = 'operation', defaultValue: T) {
    return (error: any): Observable<T> => {
      console.error(`${operation} failed: `, error);
      return of(defaultValue);
    };
  }
}